
export default {
  useList(item) {
    let views = ['large_amount', 'age', 'period', 'year' ]
    return item.list && !('options' in item) && (item.type.length > 1 || !views.includes(item.type[0]))
  },
  type2Str(type) {
    let m = {
      term_life: "寿险",
      critical_illness: "重疾险",
      medical: "医疗险",
      accident: "意外险",
      annual: "年金险"
    };

    return m[type] || type
  }
}
